export default function SubscriptionWrapper() {
    this.count = 0;
    this.subscription = null;
}

SubscriptionWrapper.prototype = {
    decrease: function () {
        this.count--;
        if (this.count <= 0) {
            this.dispose();
        }
    },
    increase: function () {
        this.count++;
    },
    dispose: function () {
        this.subscription && this.subscription.dispose();
        this.count = 0;
        this.subscription = null;
    },
};
